import * as React from "react";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import ViewClub from "../AdminDataBaseSystem/ViewClub";
import Home from "../AdminDataBaseSystem/Home";
import Projects from "../AdminDataBaseSystem/Projects";
import Events from "../AdminDataBaseSystem/Events";
import Member from "../AdminDataBaseSystem/Member";
import Report from "../AdminDataBaseSystem/Report";
import Calender from "../AdminDataBaseSystem/Calender";
import Cabinet from "../AdminDataBaseSystem/Cabinet";
import InputProjects from "../AdminDataBaseSystem/InputProjects";
import InputEvent from "../AdminDataBaseSystem/InputEvent";
import Update from "../AdminDataBaseSystem/Update";
import DGdairyInput from "../AdminDataBaseSystem/DGDiaryInput";
import UpdateClub from "../AdminDataBaseSystem/UpdateClub";
import { Avatar } from "@mui/material";
import { FaCaretDown } from "react-icons/fa";
import LogoutIcon from "@mui/icons-material/Logout";
// import logo from '../img/320d.jpg';
import Multiple from "../AdminDataBaseSystem/Multiple";
import International from "../AdminDataBaseSystem/International";
import Dollar from "../AdminDataBaseSystem/Dolor";
import InternationalUpdate from "../AdminDataBaseSystem/InternationalUpdate";
import Menu from "../AdminDataBaseSystem/Menu";
import DgDiary from "../AdminDataBaseSystem/DG-Diary";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import ProjectUpdate from "../AdminDataBaseSystem/ProjectUpdate";
import DGDiaryUpdate from "../AdminDataBaseSystem/DGDiaryUpdate";
import EventUpdate from "../AdminDataBaseSystem/EventUpdate";
import Advertisement from "../AdminDataBaseSystem/Advertisement";
import NotificationMessage from "../AdminDataBaseSystem/NotificationMessage";
import RegisterUsers from "../AdminDataBaseSystem/RegisterUsers";
import Gallery from "../AdminDataBaseSystem/gallery";
import logo from "../img/logo.png";
import UserForm from "../AdminDataBaseSystem/UserForm";
import Meetings from "../AdminDataBaseSystem/Meetings";

import MembersTable from "../AdminDataBaseSystem/MembersTable";
import Cabinett from "../Cabinet/Cabinet";
import ChildSafety from "../ChildSafety/ChildSafety";
import Contact from "../AdminDataBaseSystem/Contact";
import { useState } from "react";
import { useEffect } from "react";
import DistrictApproval from "../AdminDataBaseSystem/DistrictApproval";
import District from "../AdminDataBaseSystem/District";
import OtpVerification from "../AdminDataBaseSystem/OtpVerification";
import SignupScreen from "../AppPreview/SignupScreen";
import LoginScreen from "../AppPreview/LoginScreen";
import HomeScreen from "../AppPreview/HomeScreen";
import InternationalWebPage from "../AppPreview/International";
import DistrictScreen from "../AppPreview/District";
import MultipleDgWeb from "../AppPreview/MultipleDgWeb";
import ClubWeb from "../AppPreview/ClubWeb";
import MemberWeb from "../AppPreview/MemberWeb";
import ImagePickerWeb from "../AppPreview/ImagePickerWeb";
import GalleryWeb from "../AppPreview/GalleryWeb";
import ProfilePage from "../AppPreview/ProfilePage";
import DollarRateWeb from "../AppPreview/DollarRate";
import DGDiaryWeb from "../AppPreview/DGDiaryWeb";
import BamaWeb from "../AppPreview/BamaWeb";
import EventsWeb from "../AppPreview/EventsWeb";
import ContactWeb from "../AppPreview/ContactWeb";
import NotificationWeb from "../AppPreview/NotificationWeb";
import ContestRule from "../AdminDataBaseSystem/ContestRule";
import UpdateC from "../AdminDataBaseSystem/UpdateC";
import DownloadMaster from "../AdminDataBaseSystem/DownloadMaster";
import Downloads from "../AdminDataBaseSystem/Downloads";
import BAMAList from "../AppPreview/BamaWeb";
import MenuAdvertisement from "../AdminDataBaseSystem/MenuAdvertisement";
import ClubMember from "../ClubLogin/ClubMember";
import AddressBook from "../AdminDataBaseSystem/AddressBook";
import NotificationMessageAndrod from "../AdminDataBaseSystem/NotificationMessageAndrod";
import ClubMasterLogs from "../AdminDataBaseSystem/ClubMasterLogs";
import MemberMasterLogs from "../AdminDataBaseSystem/MemberMasterLogs";
import CabinetMasterLogs from "../AdminDataBaseSystem/CabinetMasterLogs";

function Navigation(props) {
  const navigate = useNavigate();

  const logout = () => {
    sessionStorage.removeItem("email"); // Clear session storage
    sessionStorage.removeItem("usertype");
    sessionStorage.removeItem("id"); // Clear user type if stored
    sessionStorage.removeItem("dist");
    sessionStorage.removeItem("role");
    props.condition(null); // Update state to trigger logout
    navigate("/login"); // Redirect to login page
  };

  const [dist, setDist] = useState("");

  useEffect(() => {
    const storedDist = sessionStorage.getItem("dist");
    if (storedDist) {
      setDist(storedDist);
    }
  }, []);

  return (
    <div className="pb-4">
      <>
        <Navbar
          className="navbarStyle shadow p-4"
          fixed="top"
          bg="white"
          variant=""
        >
          <Container>
            {/* <Navbar.Brand href="#home">
              <h2>
                {" "}
                <strong className="adminDashboardHeading">
                  Admin Dashboard !...
                </strong>
              </h2>

              <Link
                style={{
                  textDecoration: "none",
                  fontSize: "1.4rem",
                  color: "rgb(245, 170, 30)",
                }}
                to=""
              >
                Home/Dashboard {dist}
              </Link>
            </Navbar.Brand> */}
            <Navbar.Brand href="#home">
  <h2>
    {" "}
    <strong className="adminDashboardHeading">
      {/* ✅ Displays contextual header based on user role definitions */}
      {sessionStorage.getItem("role") === "clubAdmin" 
        ? "Club Dashboard !..." 
        : "Admin Dashboard !..."
      }
    </strong>
  </h2>

  <Link
    style={{
      textDecoration: "none",
      fontSize: "1.4rem",
      color: "rgb(245, 170, 30)",
    }}
    to=""
  >
    {/* ✅ Shows "Club Info" or "Home/Dashboard" along with the active district value */}
    {sessionStorage.getItem("role") === "clubAdmin"
      ? `Home/(${sessionStorage.getItem("clubName") || ""}) - Dist ${dist}`
      : `Home/Dashboard ${dist}`
    }
  </Link>
</Navbar.Brand>
            <Nav className="ms-auto">
              <div class="dropdown ms-auto">
                <a
                  class="d-flex text-white mt-2"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <Avatar className="ms-auto">
                    {" "}
                    <img src={logo} height="50px" width="50px" />
                  </Avatar>
                  <span>
                    <FaCaretDown className="me-1 mt-3 text-danger"></FaCaretDown>
                  </span>
                </a>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li>
                    <Link to="#" class="dropdown-item" href="#">
                      {" "}
                      <strong className="text-center text-primary">
                        {sessionStorage.getItem("usertype") || "User"}
                      </strong>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" class="dropdown-item" href="#">
                      <LogoutIcon></LogoutIcon>{" "}
                      <Link to="#" style={{ color: "black" }} onClick={logout}>
                        Logout
                      </Link>
                    </Link>
                  </li>
                </ul>
              </div>
            </Nav>
          </Container>
        </Navbar>

        <Container className="shadow mt-1 p-1 link-text">
          <Routes>
            <Route path="/" element={<Home></Home>} />

            <Route path="/view-project" element={<Projects></Projects>} />
            <Route path="/view-events" element={<Events></Events>} />
            <Route path="/view-calender" element={<Calender></Calender>} />
            <Route path="/view-member" element={<Member></Member>} />
            <Route path="/view-report" element={<Report></Report>} />
            <Route path="/view-club" element={<ViewClub></ViewClub>} />
            <Route path="/view-cabinet" element={<Cabinet></Cabinet>} />
              <Route path="/address-book" element={<AddressBook></AddressBook>} />
            <Route
              path="/add-project"
              element={<InputProjects></InputProjects>}
            />
            <Route path="/add-event" element={<InputEvent></InputEvent>} />
            <Route
              path="/add-DG-dairy"
              element={<DGdairyInput></DGdairyInput>}
            />
            <Route path="/update/:memberId" element={<Update></Update>} />
                 <Route path="/updatec/:memberId" element={<UpdateC></UpdateC>} />
            <Route
              path="/update-club/:clubName/:clubId"
              element={<UpdateClub></UpdateClub>}
            />
            <Route path="/multiple" element={<Multiple></Multiple>} />
            <Route
              path="/internationalUpdate/:id"
              element={<InternationalUpdate></InternationalUpdate>}
            />
            <Route
              path="/international"
              element={<International></International>}
            />
            <Route path="/dollar" element={<Dollar></Dollar>} />
            <Route path="/menu" element={<Menu></Menu>} />
            <Route
              path="/project-update/:id"
              element={<ProjectUpdate></ProjectUpdate>}
            />
            <Route path="/DG-diary" element={<DgDiary></DgDiary>} />
            <Route
              path="/DG-diary-update/:id"
              element={<DGDiaryUpdate></DGDiaryUpdate>}
            />
            <Route
              path="/event-update/:id"
              element={<EventUpdate></EventUpdate>}
            />
            <Route path="/advertisement" element={<Advertisement />} />
            <Route
              path="/notification-message"
              element={<NotificationMessage />}
            />
            <Route path="/register-users" element={<RegisterUsers />} />
 <Route path="/club-members" element={<ClubMember />} />


            <Route path="/galleryy" element={<Gallery />} />
            <Route path="/meetings" element={<Meetings />} />
            <Route path="/chairperson-users" element={<UserForm />} />

            <Route path="/member-groups" element={<MembersTable />} />
            <Route path="/cabinet" element={<Cabinett />} />
            <Route path="/Contactt" element={<Contact />} />
            <Route path="/district-approval" element={<DistrictApproval />} />
            <Route path="/cabinet-logs" element={<CabinetMasterLogs />} />
             <Route path="/member-logs" element={<MemberMasterLogs />} />
            <Route path="/club-logs" element={<ClubMasterLogs />} />
            <Route path="/app/signup" element={<SignupScreen />} />
            <Route path="/app/login" element={<LoginScreen />} />
            <Route path="/home" element={<HomeScreen />} />
            <Route
              path="/InternationalPageItem"
              element={<InternationalWebPage />}
            />
            <Route path="/District" element={<DistrictScreen />} />
            <Route path="/Multiple Information" element={<MultipleDgWeb />} />
            <Route path="/Club" element={<ClubWeb />} />
            <Route path="/Member" element={<MemberWeb />} />
            <Route path="/camera" element={<ImagePickerWeb />} />
            <Route path="/gallery" element={<GalleryWeb />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/Dollar Rate" element={<DollarRateWeb />} />
            <Route path="/DG Diary" element={<DGDiaryWeb />} />
            <Route path="/BAMA List" element={<BAMAList />} />
            <Route path="/Events" element={<EventsWeb />} />
            <Route path="/Contact" element={<ContactWeb />} />
            <Route path="/Notifications" element={<NotificationWeb />} />
            <Route path="/contest-rule" element={<ContestRule />} />
            <Route path="/download-master" element={<DownloadMaster />} />
            <Route path="/downloads" element={<Downloads />} />
            <Route path="/menus-advertisement" element={<MenuAdvertisement />}/>
               <Route path="/notification-android" element={<NotificationMessageAndrod />}/>
          </Routes>
        </Container>
      </>
    </div>
  );
}

export default Navigation;
